// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.client-header[data-v-1b50c4c6], .joint-client-header[data-v-1b50c4c6] {\n    margin-bottom: 5px !important;\n}\n.client-header-underline[data-v-1b50c4c6], .joint-client-header-underline[data-v-1b50c4c6] {\n    border: 1px solid #037397;\n}\n", ""]);
// Exports
module.exports = exports;
